export default __webpack_public_path__ + "static/media/hero-banner.be7aacbb.png";